(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class GioStockOrder extends HTMLElement {
    connectedCallback() {
      this.orderProducts = this.orderProducts.bind(this);
      this.observer = new MutationObserver(this.orderProducts);
      this.observer.observe(this, { childList: true, subtree: true });
      this.orderProducts();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    orderProducts() {
      const grid = this.querySelector('[data-testid="product-grid"]');
      if (!grid) return;

      const products = Array.from(grid.querySelectorAll(':scope > .product-grid__item'));
      const orderedProducts = products
        .filter((product) => product.dataset.productAvailable === 'true')
        .concat(products.filter((product) => product.dataset.productAvailable !== 'true'));

      const orderChanged = products.some((product, index) => product !== orderedProducts[index]);
      if (!orderChanged) return;

      this.observer.disconnect();
      for (const product of orderedProducts) grid.append(product);
      this.observer.observe(this, { childList: true, subtree: true });
    }
  }

  if (!customElements.get('gio-stock-order')) {
    customElements.define('gio-stock-order', GioStockOrder);
  }

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
